'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var PasswordInput = require('./PasswordInput.js');
var Input = require('./Input.js');

const InputTypeSelector = react.forwardRef((_a, ref)=>{
    var { type } = _a, rest = _tslib.__rest(_a, [
        "type"
    ]);
    if (type === 'password') return jsxRuntime.jsx(PasswordInput, Object.assign({
        ref: ref
    }, rest));
    return jsxRuntime.jsx(Input, Object.assign({
        ref: ref
    }, rest));
});
InputTypeSelector.displayName = 'InputTypeSelector';

module.exports = InputTypeSelector;
